export const en = {
    safariCantPlay: "Unable to display video on Safari",
    tryChrome: 'Try Chrome'
}

export type Type = typeof en;